// Chakra imports
import { Flex } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import Categorie from "./components/Categorie";
import { tablesTableData } from "variables/general";
// import productService from "../../../api/products/products";
import categorieService from "../../../api/categories/categories";

function Tables() {
  const [products, setProducts] = useState([]); // État pour stocker les produits
  const [loading, setLoading] = useState(true); // État pour gérer le chargement
  const [error, setError] = useState(null); // État pour gérer les erreurs

  useEffect(() => {
    // Fonction pour récupérer les produits
    const fetchProducts = async () => {
      try {
        setLoading(true); // Activer l'état de chargement
        const response = await categorieService.getCategories();
        console.log(response)
        setProducts(response); // Stocker les données récupérées
      } catch (err) {
        console.error("Erreur lors de la récupération des produits :", err);
        setError(err.message || "Une erreur s'est produite.");
      } finally {
        setLoading(false); // Désactiver l'état de chargement
      }
    };

    fetchProducts(); // Appeler la fonction de récupération
  }, []); // Le tableau vide assure que l'effet s'exécute une seule fois au montage

  return (
    <Flex direction="column" pt={{ base: "120px", md: "75px" }}>
      <Categorie
        title={"Catégorie"}
        captions={["Id", "Nom de la catégorie", "Crée le", ""]}
        data={loading ? [] : products} // Afficher les données récupérées ou un tableau vide si en chargement
      />
      {/* {loading && <p>Chargement des produits...</p>} {/* Afficher un message de chargement */}
      {/* {error && <p style={{ color: "red" }}>Erreur : {error}</p>} Afficher les erreurs */}
    </Flex>
  );
}

export default Tables;
